import { GraniteInput } from 'components/V2/Input/GraniteInput';
import { useBrandContext } from 'context/BrandProvider';
import debounce from 'lodash.debounce';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import chroma from 'chroma-js';

interface ColorInputProps {
  name: string;
  label: string;
}

const ColorInput: React.FC<ColorInputProps> = ({ name, label }) => {
  const { control } = useFormContext();
  const { onUpdateBrand } = useBrandContext();

  const onDebounceChange = debounce((value: string) => {
    onUpdateBrand({ [name]: value });
  }, 700);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => {
        return (
          <GraniteInput
            {...field}
            label={label}
            innerInputClassName="w-full"
            className="w-full"
            maxLength={9}
            value={field.value ? `#${field.value.replaceAll('#', '')}` : '#'}
            onChange={(e) => {
              let value = e.target.value.toUpperCase();

              value = `#${value.replaceAll('#', '')}`;

              if (value === '#') value = '';

              let debouncedValue = '';
              if (value && chroma.valid(value)) {
                debouncedValue = value;
              }

              onDebounceChange(debouncedValue);
              field.onChange(value);
            }}
            error={error?.message}
            leftSuffix={
              <input
                type="color"
                value={field.value || '#FFFFFF'}
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();
                  onDebounceChange(value);
                  field.onChange(value);
                }}
                className="h-4 w-4 cursor-pointer"
                style={{
                  WebkitAppearance: 'none',
                  MozAppearance: 'none',
                  appearance: 'none',
                  padding: 0,
                  border: '1px solid #6b7280',
                  borderRadius: '4px',
                  background: 'none',
                }}
              />
            }
          />
        );
      }}
    />
  );
};

export default ColorInput;
